import { render } from "./FilterStudentPlatform.vue?vue&type=template&id=f4316050&scoped=true"
import script from "./FilterStudentPlatform.vue?vue&type=script&lang=js"
export * from "./FilterStudentPlatform.vue?vue&type=script&lang=js"

import "./FilterStudentPlatform.vue?vue&type=style&index=0&id=f4316050&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4316050"]])

export default __exports__